import { observer } from "mobx-react-lite";
import { useMemo } from "react";

import {
  type WorkoutItemSetProviderProps,
  workoutItemSetContext,
} from "src/workouts/WorkoutItemSetContext.shared";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

export const PreviewWorkoutItemWorkoutSetProvider = observer(
  function ReadOnlyWorkoutItemWorkoutSetProvider(
    props: WorkoutItemSetProviderProps,
  ) {
    const workoutItemsPermissions = useWorkoutPermissions();

    const value = useMemo(() => {
      return {
        getType: () => {
          return props.attribute.exerciseAttribute.type;
        },
        updateEditableValue: () => {},
        getEditableValue: () => {
          if (!props.attributeValue) {
            return "";
          }

          return props.attributeValue.assignedValue;
        },
        getEditableInputId: () => {
          return `${props.workoutSet.id}:${props.attribute.exerciseAttributeId}:${props.attribute.exerciseAttribute.type}`;
        },
        isEditableInputDisabled: () => {
          return !workoutItemsPermissions.canLogSets;
        },
        renderAssignedValue: () => {
          return null;
        },
      };
    }, [
      props.attributeValue?.assignedValue,
      props.attributeValue?.trackedValue,
      props.attribute.exerciseAttribute.type,
      props.attribute.exerciseAttributeId,
      props.workoutSet.id,
      workoutItemsPermissions.canLogSets,
    ]);

    return (
      <workoutItemSetContext.Provider value={value}>
        {props.children}
      </workoutItemSetContext.Provider>
    );
  },
);
